'use client';
import { LicenseInfo } from '@mui/x-license';

LicenseInfo.setLicenseKey('ce875dfd29b9bb03b1ccd632c8b409aaTz0xMDUzMTEsRT0xNzY3OTE2Nzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=');

export default function MuiXLicense() {
  return null;
}
